<div class="nav-padding"></div>
<mat-toolbar class="header-landing">
  <button
    mat-icon-button
    class="mobile-burger"
    [matMenuTriggerFor]="hamburgerMenu"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <mat-menu #hamburgerMenu="matMenu">
    <button
      mat-menu-item
      routerLink="/auth/register"
    >
      Sign up for free
    </button>
    <button
      mat-menu-item
      routerLink="/auth/login"
    >
      Log in
    </button>
  </mat-menu>

  <app-logo />

  <div class="landing-desktop-buttons-container">
    <button
      mat-stroked-button
      color="primary"
      routerLink="/auth/login"
    >
      Log in
    </button>
    <button
      mat-flat-button
      color="primary"
      routerLink="/auth/register"
    >
      Sign up for free
    </button>
  </div>

  <div class="mobile-only">
    <button
      mat-flat-button
      color="primary"
      routerLink="/auth/register"
    >
      Sign up
    </button>
  </div>
</mat-toolbar>
